export default __webpack_public_path__ + "static/media/ss3.383ee1bb.jpg";